import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/TrackingIdLocales.ts
var n = ({ language: e, country: t, currency: n }) => `${e}-${t}-${n}`, r = class r extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/trackingidcatalogmappings`;
	}
	async list(e) {
		let t = await this.api.get(this.buildPath(`${r.baseUrl}`, e));
		return t.items = (t.items ?? []).reduce((e, t) => {
			let n = e.find((e) => e.trackingId === t.trackingId);
			return n ? n.trackingIdToCatalogMapping = n.trackingIdToCatalogMapping.concat(t.trackingIdToCatalogMapping) : e.push(t), e;
		}, []).reduce((e, t) => (t.trackingIdToCatalogMapping.sort((e, t) => e.primary ? -1 : t.primary || n(e) > n(t) ? 1 : -1), e.push(t), e), []), t;
	}
	create(e) {
		return this.api.post(r.baseUrl, e);
	}
	delete(e) {
		return this.api.delete(this.buildPath(`${r.baseUrl}`, { trackingId: e }));
	}
	flatUpdate(e, t) {
		return this.api.put(`${r.baseUrl}/flat/${e}`, t);
	}
	flatDelete(e) {
		return this.api.delete(this.buildPath(`${r.baseUrl}/flat/${e}`));
	}
	flatCreate(e) {
		return this.api.post(`${r.baseUrl}/flat`, e);
	}
	flatListByProject(e) {
		return this.api.post(`${r.baseUrl}/flat/list`, e);
	}
};
export { r as TrackingIdLocales };

//# sourceMappingURL=TrackingIdLocales.js.map